import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config";
import MsalErrorExecption from "../exceptions/MsalException";
import { ReactNode } from "react";
import { AuthProvider } from "./AuthProvider";

const msalInstance = new PublicClientApplication(msalConfig as any);

interface AzureProviderProps {
  children: ReactNode;
}

const AzureProvider = ({ children }: AzureProviderProps) => {
  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        errorComponent={MsalErrorExecption}
      >
        <AuthProvider>{children}</AuthProvider>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};

export default AzureProvider;
